export function stickyHeader() {
    const body = document.body;
    const wrapper = document.querySelector('.wrapper');
    const header = document.querySelector('.header');
    const headerNotification = document.querySelector('.header-notification');
    let offsetTop = 0;
    let lastScroll = 0;

    function stickyHeader() {
        if (header) {
            let currentScroll = window.scrollY;
            if (currentScroll === 0) {
                body.classList.remove("up");
                header.classList.remove("sticky");
                if (headerNotification) {
                    headerNotification.style.marginTop = 0 + 'px';
                }
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains("down")) {
                body.classList.remove("up");
                body.classList.add("down");
            } else if (currentScroll < lastScroll && body.classList.contains("down")) {
                body.classList.remove("down");
                body.classList.add("up");
            }
            lastScroll = currentScroll;

            if (currentScroll > offsetTop) {
                header.classList.add("sticky");
            }
        }
        if (headerNotification && header.classList.contains('sticky')) {
            headerNotification.style.marginTop = -offsetTop + 'px';
        }
    }

    function setWrapperPaddingIfBannerExists() {
        if (headerNotification) {
            offsetTop = headerNotification.clientHeight;
            if (wrapper.classList.contains("header-notification-hide")) {
                offsetTop = 0;
            } else {
                wrapper.style.paddingTop = offsetTop + 'px';
            }
        }
    }

    window.addEventListener("load", () => {
        stickyHeader();
        setWrapperPaddingIfBannerExists();
    });
    window.addEventListener("scroll", () => {
        stickyHeader();
    });
    window.addEventListener("resize", () => {
        setWrapperPaddingIfBannerExists();
    });


    //cookie
    if (headerNotification) {
        let acceptCookie = headerNotification.querySelector("button");

        if (document.cookie.indexOf("headerNotificationAccess=") >= 0) {
            headerNotification.style.display = 'none';
            wrapper.style.paddingTop = 0 + 'px';
            body.classList.add("header-notification-hide");
        } else {
            headerNotification.style.display = 'flex';
            body.classList.remove("header-notification-hide");
        }

        acceptCookie.addEventListener("click", function (e) {
            e.preventDefault();

            let expiry = new Date();
            expiry.setTime(expiry.getTime() + 1 * 24 * 60 * 60 * 1000);
            document.cookie = "headerNotificationAccess=yes; path=/; expires=" + expiry.toGMTString();
            headerNotification.style.display = 'none';
            wrapper.style.paddingTop = 0 + 'px';
            offsetTop = 0;
            body.classList.add("header-notification-hide");
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js